module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<!-- assets/scripts/templates/test.lodash.tpl -->\n\nDies ist ein Test\n' +
((__t = ( test )) == null ? '' : __t) +
'\n\n';
 numbers.forEach( num => { ;
__p +=
((__t = ( (num + ' ') )) == null ? '' : __t) +
' ';
 }) ;
__p += '\n';

}
return __p
};
